'use client'
import { ClientWorkspaceModule } from '@repo/client-matter-workspaces/ClientWorkspaceModule'

const ClientWorkspace = () => {
  return <ClientWorkspaceModule />
}

export default ClientWorkspace
